export interface Payment {
  id: string;
  transactionNumber: string;
  amount: number;
  paymentDate: string;
  paymentMethod: string;
  reference?: string;
  status: PaymentStatus;
  notes?: string;
  companyId: string;
  customerId?: string;
  vendorId?: string;
  invoiceId?: string;
  billId?: string;
  bankAccountId?: string;
  createdAt: string;
  updatedAt: string;
  customer?: {
    id: string;
    name: string;
    email?: string;
  };
  vendor?: {
    id: string;
    name: string;
    email?: string;
  };
  invoice?: {
    id: string;
    invoiceNumber: string;
    total: number;
    template?: {
      id: string;
      name: string;
      templateCompanyName: string;
      templateLogo?: string | null;
      logoBase64?: string | null;
      layoutType: 'modern' | 'classic';
      colorScheme: {
        primary: string;
        secondary: string;
        text: string;
        background: string;
      };
      fontFamily: string;
    };
  };
  bill?: {
    id: string;
    billNumber: string;
    total: number;
  };
}

export type PaymentStatus = 'PENDING' | 'COMPLETED' | 'FAILED' | 'CANCELLED';

export interface CreatePaymentData {
  amount: number;
  paymentDate?: string;
  paymentMethod?: string;
  reference?: string;
  notes?: string;
  customerId?: string;
  vendorId?: string;
  invoiceId?: string;
  billId?: string;
  bankAccountId?: string;
}

export interface UpdatePaymentData extends Partial<CreatePaymentData> {
  status?: PaymentStatus;
}

export interface PaymentFilters {
  page?: number;
  limit?: number;
  customerId?: string;
  search?: string;
}

export interface PaymentsResponse {
  payments: Payment[];
  pagination: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
  };
}

export interface UnpaidInvoice {
  id: string;
  invoiceNumber: string;
  issueDate: string;
  dueDate: string;
  total: number;
  paidAmount: number;
  remainingAmount: number;
  status: string;
}

export interface InvoiceAllocation {
  invoiceId: string;
  amount: number;
}

export interface CreateCustomerPaymentData {
  customerId: string;
  totalAmount: number;
  paymentDate?: string;
  paymentMethod?: string;
  reference?: string;
  notes?: string;
  bankAccountId?: string;
  invoiceAllocations?: InvoiceAllocation[];
}

export const PAYMENT_METHODS = [
  { value: 'cash', label: 'Cash' },
  { value: 'bank_transfer', label: 'Bank Transfer' },
  { value: 'credit_card', label: 'Credit Card' },
  { value: 'debit_card', label: 'Debit Card' },
  { value: 'check', label: 'Check' },
  { value: 'paypal', label: 'PayPal' },
  { value: 'stripe', label: 'Stripe' },
  { value: 'other', label: 'Other' }
] as const;

export const PAYMENT_STATUS_LABELS: Record<PaymentStatus, string> = {
  PENDING: 'Pending',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  CANCELLED: 'Cancelled'
};

export const PAYMENT_STATUS_COLORS: Record<PaymentStatus, string> = {
  PENDING: 'bg-yellow-100 text-yellow-800',
  COMPLETED: 'bg-green-100 text-green-800',
  FAILED: 'bg-red-100 text-red-800',
  CANCELLED: 'bg-gray-100 text-gray-800'
};